import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const ADDTABLE = "addTable";
export const ADDFORM = "addForm";
export const DELETEtABLE = "deleteTable";
export const GETROLES = "getRoles";
export const USERS = "users";
export const MODIFY_USER_PW = 'userItem_pw'
//mutations types
export const SETTABLE = "setTable";


const state = {
    tablesData: []
};


const actions = {
    // [CHANGE_MENUS]({ commit }) {
    //   commit(SET_CHANGE_MENUS, MENU);
    //   return MENU;
    // },
    [MODIFY_USER_PW]({ commit }, id) {
        console.log(commit)
        return ApiService.put(`/api-user/users/${id}/password`);
    },
    [USERS]({ commit }, o) {
        console.log(commit)
        return ApiService.put(`/api-user/users`, o, { type: 'json' })
    },
    [GETROLES]() {
        return ApiService.get(`/api-user/roles`);
    },
    [DELETEtABLE]({ commit }, id) {
        console.log(commit)
        return ApiService.delete(`/api-user/users/${id}`);
    },
    [ADDFORM]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-user/users/saveOrUpdate`, o, { type: 'json' })
    },
    [ADDTABLE]({ commit }, { page, limit, selectKey, selectValue }) {
        console.log(commit)
        return ApiService.get(`/api-user/users?${selectKey}=${selectValue}&page=${page}&limit=${limit}`)
    },

};
const mutations = {
    [SETTABLE](state, data) {
        state.tablesData = data;
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
